/**
 * « Paramètres des volontaires » (`staff/configuration`): the head and its link, then the five sections
 * top to bottom (dates, access, places, form, notes), then Save. Each section step opens its card
 * (`section`); the anchors come from `tourKey={section}` on OrganizerSection (VolunteerSettingsPage).
 */
export const VOLUNTEER_SETTINGS_TOUR = {
    id: 'volunteer-settings',
    version: 1,
    paths: ['staff/configuration'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Your call for volunteers',
            description:
                'Set up here how volunteers apply: dates, places, the form. « Preview » opens the form as they will see it.',
        },
        {
            key: 'link',
            target: '[data-tour="page-copy-link"]',
            placement: 'bottom',
            title: 'The application link',
            description: 'Copies the address of the volunteer form, to share it with your future volunteers.',
        },
        {
            key: 'dates',
            target: '[data-tour="sec-vpub"]',
            section: 'vpub',
            placement: 'bottom',
            title: 'Application dates',
            description:
                'Applications open and close on these dates by themselves. Without an opening date, the form stays closed.',
        },
        {
            key: 'access',
            target: '[data-tour="sec-vaccess"]',
            section: 'vaccess',
            placement: 'bottom',
            title: 'Access and changes',
            description:
                'Protect the form with a code if you wish, and choose until when a volunteer can edit their application.',
        },
        {
            key: 'capacity',
            target: '[data-tour="sec-vcap"]',
            section: 'vcap',
            placement: 'bottom',
            title: 'How many volunteers',
            description: 'Enter the number of volunteers you need. Leave it empty for no limit.',
        },
        {
            key: 'fields',
            target: '[data-tour="sec-vfields"]',
            section: 'vfields',
            placement: 'bottom',
            title: 'The application form',
            description:
                'The questions volunteers answer. The role is always asked: you choose the list of roles to fill. « Add a field » adds a question.',
        },
        {
            key: 'notes',
            target: '[data-tour="sec-vnotes"]',
            section: 'vnotes',
            placement: 'bottom',
            title: 'Your messages to volunteers',
            description: 'Instructions shown on the form and in the confirmation they receive.',
        },
        {
            key: 'save',
            target: '[data-tour="page-save"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Save your changes',
            description:
                'Nothing applies until you save. While an essential setting is missing, you save a draft and the form stays closed.',
        },
    ],
}

export default VOLUNTEER_SETTINGS_TOUR
